<template>
  <div>
    <div class="d-flex dkl-title-h4" :class="addNewAnswer ? '' : 'mb-3'"><h4>{{ $t('actual_status') }}</h4><a class="dkl-btn btn-md rounded-circle pull-right" href="#" @click.prevent="showNewAnswer"><i class="fa fa-plus" aria-hidden="true"></i></a></div>
    <div v-if="addNewAnswer">
      <div class="form-group row">
        <div class="col-md-12">
          <textarea class="form-control" name="comments" rows="8" v-model="newAnswer.comments"></textarea>
          <div class="input-errors" v-for="error of v$.newAnswer.comments.$errors" :key="error.$uid">
            <div class="error-msg text-danger">{{ $t('required_field') }}</div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label class="col-form-label">{{ $t('communicated_by') }} </label>
          <input class="form-control" name="given_by" type="text" v-model="newAnswer.given_by"></input>
        </div>
        <div class="col-md-6">
          <label class="col-form-label">{{ $t('actual_status') }} </label>
          <input class="form-control" name="stand" type="text" v-model="newAnswer.stand"></input>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label class="col-form-label">{{ $t('document') }}</label>
          <textarea class="form-control" name="document" v-model="newAnswer.document"></textarea>
        </div>
      </div>
    </div>
    <div v-if="Object.keys(currentGap.last_answer) > 0" class="m-t-5">
      <h4 class="card-title">{{ $t('last_status') }}</h4>
      <div class="form-group row">
        <label class="col-form-label col-md-2">{{ $t('actual_status') }}</label>
        <div class="col-md-10">
          <textarea class="form-control" v-model="currentGap.last_answer.question_answer" readonly></textarea>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-md-2">{{ $t('documents') }}</label>
        <div class="col-md-10">
          <input type="text" class="form-control" v-model="currentGap.last_answer.document" readonly>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6 d-flex">
          <label class="col-form-label" style="padding-left: 0px; padding-right: 45px">{{ $t('communicated_by') }}</label>
          <div>
            <input type="text" class="form-control col-auto" v-model="currentGap.last_answer.given_by" readonly>
          </div>
        </div>
        <div class="col-md-6 d-flex">
          <label class="col-form-label col-auto">{{ $t('actual_status') }}</label>
          <div>
            <input type="text" class="form-control col-auto" v-model="currentGap.last_answer.stand" readonly>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {newAnswer} from "@/utils/enums";
import {deepCopy} from "@/utils";
import {mapState} from "vuex";

export default {
  name: "AnswerComponent",
  props: {
    currentGap: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      addNewAnswer: false,
      newAnswer: {}
    }
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, language: state => state.app.language}),
  },
  methods: {
    showNewAnswer(e) {
      e.preventDefault();
      this.newAnswer = deepCopy(newAnswer)
      const language_postfix = this.language === 'de' ? '' : '_en'
      if (this.currentGap) {
        this.newAnswer.yes = this.currentGap[`statement_yes${language_postfix}`];
        this.newAnswer.no = this.currentGap[`statement_no${language_postfix}`];
        this.newAnswer.partial = this.currentGap[`statement_partial${language_postfix}`];
        this.newAnswer.irrelevant = this.currentGap[`statement_irrelevant${language_postfix}`];
      }
      this.newAnswer.given_by = this.userName;
      this.addNewAnswer = true;
    },
  }
}
</script>

<style scoped>

</style>
